module.exports = __webpack_public_path__ + "img/icons.c82d9b27.svg";